import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITipoTramite, ITipoTramiteActividad, TipoTramiteActividaGeneralDto } from '../../../../shared/interfaces/database/configuracion';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormularioService } from '../../../../services/database/formulario.service';
import { CustomTitle, FormGroupErrorMessageComponent, FormNoData } from 'lib-base';
import { CommonModule } from '@angular/common';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { PanelModule } from 'primeng/panel';

@Component({
  selector: 'app-actividad-general',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DropdownModule,
    TranslateModule, FormGroupErrorMessageComponent,
    TranslateModule, PanelModule],
  template: `
  <p-panel [header]="'msg.configuraciónActividadGeneral' | translate" class="w-full">
    <div class="grid formgrid p-fluid" [formGroup]="form">
      <div class="field col-12 md:col-12">
        <label for="formularioId" class="ml-3">
          {{'common.formulario' | translate}}
          <span style="color: red">*</span>
        </label>
        <div class="flex gap-1 justify-content-start">
          <p-dropdown [options]="formularios" formControlName="formularioId" appendTo="body"
            placeholder="Select" optionLabel="nombre" optionValue="id" [filter]="true"
            autoWidth="false" class="flex-grow-1">
          </p-dropdown>
        </div>
        <small *ngIf="formularioNotLatestVersion" class="p-error block">
            {{'common.noUltimaVersion' | translate}}
          </small>
        <ng-container
          *ngIf="form.get('formularioId')?.invalid && form.get('formularioId')?.dirty">
          <app-form-group-error-message
            [control]="form.get('formularioId')"></app-form-group-error-message>
        </ng-container>
      </div>
    </div>
  </p-panel>
  `
})
export class ActividadGeneralComponent implements OnInit {

  @Input() tipoTramite !: ITipoTramite;
  @Input() editActividad !: ITipoTramiteActividad | undefined;
  @Input() parentForm !: FormGroup;
  @Output() onFormSelected = new EventEmitter<number>();

  formularios !: FormNoData[];
  formulariosReady: boolean = false;
  formularioNotLatestVersion: boolean = false;
  form !: FormGroup;

  constructor(private _fs: FormularioService, private readonly _fb: FormBuilder) { }

  ngOnInit(): void {
    this.configurarForm();
    this.getFormsNoData();
  }

  get formFormularioId() {
    return this.form.get('formularioId')?.value;
  }

  configurarForm() {
    this.form = this._fb.group({
      formularioId: [this.editActividad?.formularioId ?? null, [Validators.required]]
    });
    setTimeout(() => {
      this.parentForm.addControl('general', this.form);
    });
    this.getFormsNoData();
    this.formSubscriptions();
    this.tryToConfigureFormulario();
  }

  formSubscriptions() {
    this.form.get('formularioId')?.valueChanges.subscribe((value: any) => {
      this.onFormSelected.emit(value);
    });
  }

  getFormsNoData() {
    this._fs.getFormsNoData().subscribe({
      next: (data: FormNoData[]) => {
        this.formularios = data;
        if (this.editActividad?.formularioId) {
          this.onFormSelected.emit(this.editActividad.formularioId);
        }
        this.formulariosReady = true;
        this.tryToConfigureFormulario();
      }
    });
  }

  findFormulario(formId: number): FormNoData | undefined {
    return this.formularios.find(f => f.id === formId);
  }

  tryToConfigureFormulario() {
    if (!this.formulariosReady && this.formFormularioId)
      return;
    const formulario = this.findFormulario(this.formFormularioId);
    if (formulario?.version !== this.editActividad?.formularioVersion)
      this.formularioNotLatestVersion = true;
  }

  getValues(): TipoTramiteActividaGeneralDto {
    const formulario = this.formularios.find(f => f.id === this.formFormularioId);
    let values = {
      formularioId: formulario?.id,
      formularioVersion: formulario?.version
    } as TipoTramiteActividaGeneralDto;

    return values;
  }

}
